/** Match only URLs accepted by a public gate. Unknown paths use normal auth boot. */
export function isStandaloneRoute(loc: Pick<Location, "hash" | "pathname">) {
  const hash = loc.hash.startsWith("#/");
  const path = hash ? loc.hash.slice(1) : loc.pathname;
  if (/^\/m\/[A-Za-z0-9_-]{1,128}\/?$/.test(path)) return true;
  if (/^\/(?:sign|p)\/[A-Za-z0-9_-]+\/?$/.test(path)) return true;
  if (hash && /^\/(?:sign|p)\/[A-Za-z0-9_-]+/.test(path)) return true;
  if (/^\/(?:i|pay)\/[A-Za-z0-9_.-]+\/?(?:\?|$)/.test(path)) return true;
  if (
    hash
      ? /^\/document-(?:sign|view)\/[A-Za-z0-9_%.-]+/.test(path)
      : /^\/document-(?:sign|view)\/[A-Za-z0-9_-]+$/.test(path)
  )
    return true;
  if (/^\/book\/manage\/[A-Za-z0-9_.-]{1,2048}\/?$/.test(path)) return true;
  if (/^\/(?:book|services)\/[a-z0-9-]{1,80}\/[a-z0-9-]{1,80}\/?$/.test(path))
    return true;
  if (/^\/(?:f|chat)\/[^/?#]{1,4096}(?:\?.+)?$/.test(path)) return true;
  if (
    /^\/(?:affiliates\/join|affiliate-portal|referral)\/[a-zA-Z0-9-]+(?:\?|$)/.test(
      path,
    )
  )
    return true;
  return (
    /^\/security\/?(?:\?.*)?$/.test(path) ||
    (hash &&
      loc.pathname === "/" &&
      /^\/ai-connect\/verify(?:\?.*)?$/.test(path))
  );
}

/** A public-only tab needs auth bootstrap before entering the business app. */
export function watchEntryMode() {
  const standalone = isStandaloneRoute(window.location);
  const check = () => {
    // An already initialized app can show public gates in-place. Keeping that
    // navigation in-place also preserves demo edits and ongoing app state.
    if (standalone && !isStandaloneRoute(window.location))
      window.location.reload();
  };
  window.addEventListener("hashchange", check);
  window.addEventListener("popstate", check);
}
